import { render, staticRenderFns } from "./LikertTypeCompleted.vue?vue&type=template&id=47445f37&scoped=true&"
import script from "./LikertTypeCompleted.vue?vue&type=script&lang=js&"
export * from "./LikertTypeCompleted.vue?vue&type=script&lang=js&"
import style0 from "./LikertTypeCompleted.vue?vue&type=style&index=0&id=47445f37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47445f37",
  null
  
)

export default component.exports